export class Coupon {
  public id?: number;
  public created?: Date;
  public expirationDate?: Date;
  public amount?: number;
  public isActive?: boolean;
  public dbRowVersion?: string;
  public couponCode?: string;
}
